// Dynamically set API base URL based on current website's origin
export const getApiBaseUrl = () => {
  if (
    window.location.origin.includes("dev") ||
    window.location.origin.includes("localhost")
  ) {
    return "https://api.dev.numbers.ag";
  }

  return "https://api.app.numbers.ag";
};
